import { Injectable } from '@angular/core';
import { Term } from './model/term.model';
import { TermsDataService } from './termos-data.service';

@Injectable({
  providedIn: 'root',
})
export class TermsMockService implements TermsDataService {
  private terms: Term[] = [
    {
      title: 'Regras e parâmetros de atuação da Itaú Corretora de Valores S.A.',
      description: 'Regras term!\r\n This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'regras'
    },
    {
      title: 'Proposta de intermediação de negócios nas bolsas de valores, de mercadorias e de futuros',
      description: 'Proposta term!\r\n This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'bolsa'
    },
    {
      title: 'Declaração do Cliente',
      description: 'Declaração term!\r\n This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'declarac'
    },
    {
      title: 'Condição de acesso',
      description: 'condição term!\r\n This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'condic'
    },
    {
      title: 'Declaração do investidor',
      description: 'declaração term!\r\n This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'investidor'
    },
    {
      title: 'Termos de uso e política de privacidade',
      description: 'A privacidade, a proteção de Dados Pessoais. This is my string descrição Lorem ipsum, dolor sitamet consectetur adipisicing elit. Reiciendis, nesciunt',
      type: 'uso'
    },
  ];

  getTerms(type: string): Promise<Term> {
    return new Promise(resolve => setTimeout(() => resolve(this.terms.filter(term => term.type === type)[0]), 2000));
  }

}
